export default __webpack_public_path__ + "static/media/contact-person.c0c3becb.svg";